import debounce from 'lodash.debounce';

import isWebView from '~/utils/isWebView';

const scrollToField = (scrollToNextSection: boolean, element: HTMLDivElement) => {
  const TROTTLE = isWebView() ? -50 : 200;

  if (scrollToNextSection && element) {
    const rect = element.getBoundingClientRect();
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const elementTop = rect.top + scrollTop;
    const elementBottom = elementTop + element.scrollHeight - TROTTLE;

    window.scrollTo({
      top: elementBottom,
      behavior: 'smooth',
    });
  }
};

const autoScrollToNextField = debounce(scrollToField, 200);

export default autoScrollToNextField;
